"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/CanceledNotice.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

const CanceledNotice = () => (
  _react2.default.createElement('div', { className: "file-message--canceled-notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 4}}
    , _react2.default.createElement('span', { className: "file-message--canceled-notice--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 5}}, "Canceled")
  )
)

exports. default = CanceledNotice
